// extracted by mini-css-extract-plugin
module.exports = {"spec_table":"styles_spec_table__LJRbi","full":"styles_full__9vdyh"};